<template>
  <ul id="list-tasks">
    <li>
      <div class="oblea">
        <div>
          <span id="producto">Pedido: {{item.Numero}}</span> 
          <span id="iconVer" class="labels" @click="btnVer"> <img class="icon-ver" src="/dist/icon-ver.png" /> VER  </span>
        </div>  
        <p id="fecha">{{item.Fecha | filterFecha}}</p> 
        <div id="divImporte">
          <span class="valores" id="importe">${{item.MontoTotal | formatMoney}}</span> 
          <span class="labels">TOTAL</span> 
        </div>
        <div id="divCantidad">
          <span class="valores" id="cantidad">{{item.CantidadItems}}</span>  
          <span class="labels">ITEMS</span> 
        </div>
      </div>
    </li>
  </ul>
</template>

 
<script>
  export default {
    name: 'item-pedido-home',

    props: ['item'],

    filters: {
      filterFecha (fecha) {
        var mes = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre']
        if (fecha!= null && fecha.length > 0)
        {
          var vFecha = fecha.split('/')
          if (vFecha.length == 3)
          {
            var numMes = parseInt(vFecha[1])
            if (numMes > 0 && numMes < 12)
            {
              var vAnioHora =  vFecha[2].split(' ')
              if (vAnioHora.length == 2)
              {
                return vFecha[0] + ' de '+ mes[numMes-1] +' '+ vAnioHora[0]+' - '+vAnioHora[1]   
              }
              else
              {
                return vFecha[0] + ' de '+ mes[numMes-1] +' '+ vFecha[2]
              }
            }
            else
            {
              return fecha
            }
          }
          else
          {
            return fecha   
          }
        }
        else
        {
          return ' ' 
        }
     
      }
    },

    methods: {
      btnVer: function () {
        this.$store.commit('pedido/savePedidoId',this.item.Id); 
        this.$router.push({ name: 'pedidoCms' });
      }
    }

  }
</script>


<style scoped>

  * {
   margin:  0;
   padding: 0;
  }
        
  li {
   float: left;
   display: block;
   padding-right: 20px;
   text-decoration: none;
  }
               
  .oblea{
    width: 190px;
    height: 120px;
    border-width: 1px;
    border: 1px solid #dddddd;
    background: #ffffff;
    padding: 10px 15px 10px 15px;
    box-shadow: 2px 2px 4px #dddddd;  
    -webkit-box-shadow: 2px 2px 4px #dddddd;  
    -moz-box-shadow:    2px 2px 4px #dddddd;  
  }

  .oblea:hover{
    background: #f9f9f9;
  }      

  #iconVer:hover{
    cursor: pointer;
  }      

  #producto{
    font-weight: 500;
    font-size: 15px;
    color: #5c666f;
  }
        
 .icon-ver{
    width: 15px;
    height: 15px;
    vertical-align: middle;
  }

 .labels{
    float: right; 
    font-size: 11px;
    color: #5c666f;
    margin-top: 8px;
    vertical-align: middle;
   }
        
        
 #fecha{
    margin-top: 4px;
    font-weight: 400;
    font-size: 9px;
    color: #5c666f;
  }
        
 .valores{
    font-weight: 500;
    font-size: 18px;
    color: #4969B2;
    vertical-align: middle;
  }
        
 #divImporte{
    margin-top: 25px;
 }
        
 #divCantidad{
    margin-top: 10px;
 }
        
        
        
</style>


// WEBPACK FOOTER //
// src/components/views/home/itemPedidoHome.vue